<div>
  <header>
    <h1 #title>{{ basketTitle }}</h1>
    <div>
      <app-text-button color="accent" routerLink="/">{{ buyMoreButton }}</app-text-button>
      <app-text-button class="checkout-button" (click)="checkout()" [disabled]="!isValidState || storeClosed">
        {{ checkoutButton }}
      </app-text-button>
    </div>
  </header>
  @if (showProductErrors) {
    <div class="basket-error">
      <h3><mat-icon svgIcon="warning"></mat-icon>{{ errorMessage.title }}</h3>
      <p>{{ errorMessage.message }}</p>
    </div>
    <app-text-button class="basket-error-button" (click)="removeInvalidBasket()">{{ errorMessage.button }}</app-text-button>
  }
  <table>
    <thead>
      <tr>
        <th scope="col" class="name-header">{{ columns.name }}</th>
        <th scope="col" class="product-price-header">{{ columns.price }}</th>
        <th scope="col" class="line-price-header">{{ columns.total }}</th>
        <th scope="col" class="quantity-header">{{ columns.quantity }}</th>
        <th scope="col" class="remove-header">{{ columns.delete }}</th>
      </tr>
    </thead>
    <app-center-section>
      @let categoryProductLineMap = productLines$ | async;
      <div class="table-content">
        @for (category of categoryProductLineMap | keyvalue; track category.key) {
          <th scope="row" class="category-header">{{ category.key }}</th>
          @for (productLine of category.value; track productLine.lineId) {
            <app-basket-overview-item
              [productLine]="productLine"
              [columns]="columns"
              [error]="showProductErrors && productLine.error"
              [simple]="simpleOverviewItems"
              (callback)="showProductErrors && validateBasket()"
            ></app-basket-overview-item>
          }
        }
      </div>

      @let prices =
        {
          total: totalPrice$ | async,
          shipping: (shipping$ | async)?.price || 0,
          products: linesTotalPrice$ | async,
          packaging: (packagingPrice$ | async) || 0,
          discount: (discount$ | async) || 0,
          giftCardDiscount: (giftCardDiscount$ | async) || 0,
          giftCardRemaining: (giftCardRemainingValue$ | async) || 0,
        };
      <div>
        <label for="total-groceries">{{ totalProductsPriceLabel }}</label>
        <span id="total-groceries">{{ prices.products | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
      </div>
      @if (allowCustomerPackaging | async) {
        <div>
          <label for="customer-packaging">{{ customerPackagingLabel }}</label>
          <app-toggle id="customer-packaging" [control]="form.controls.customerPackaging"></app-toggle>
        </div>
      }
      <div>
        <label for="total-packaging">{{ packagingPriceLabel }}</label>
        <span id="total-packaging">{{ prices.packaging | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
      </div>
      @let shippingValid = shippingValid$ | async;
      @let shipping = shipping$ | async;
      @let shippingInfo = shippingInfo$ | async;
      <div class="shipping-options">
        <label for="shippingOptions">{{ shippingPickupPriceLabel }}</label>
        @if (!shippingValid) {
          <app-text-button id="shippingOptions" color="primary" (click)="openShippingDialog()">
            {{ shippingPickupButton }}
          </app-text-button>
        }
        @if (shippingValid && shipping) {
          <app-text-button id="shippingOptions" color="accent" (click)="openShippingDialog()" [disabled]="useKioskShipping">
            @if (!shippingInfo.simpleShipping) {
              {{ isMobile ? (shipping.date.toJSDate() | date: 'shortDate') : (shipping.date.toJSDate() | date: 'fullDate') }}
              {{ shipping?.time?.period }}
            }
            @if (shippingInfo.simpleShipping) {
              {{ shippingInfo.displayName }}
            }
          </app-text-button>
        }
      </div>
      @if (prices.shipping !== undefined) {
        <div>
          @if (shippingInfo?.isDelivery && shippingPriceDeliveryLabel) {
            <label for="shipping-price">{{ shippingPriceDeliveryLabel }}</label>
          } @else {
            <label for="shipping-price">{{ shippingPriceLabel }}</label>
          }
          <span id="shipping-price">{{ prices.shipping | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        </div>
      }
      @if (prices.discount !== 0) {
        <div>
          <label for="discount">{{ discountPriceLabel }}</label>
          <span id="discount">{{ prices.discount | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        </div>
      }
      @if (prices.giftCardDiscount !== 0) {
        <div>
          <label for="giftCardDiscount">{{ giftCardDiscountPriceLabel }}</label>
          <span id="giftCardDiscount">{{ prices.giftCardDiscount | number: '.2' : locale }} {{ currency | displayCurrency }}</span>
        </div>
      }
      <div class="total-price">
        <label for="total-price">{{ totalPriceLabel }}</label>
        @let loading = isLoading$ | async;
        @if (loading) {
          <div class="loading">
            <img src="assets/preloader.gif" alt="loading price" />
          </div>
        }
        @if (!loading) {
          <span id="total-price">
            {{ prices.total | number: '.2-2' : locale }}
            {{ currency | displayCurrency }}
          </span>
        }
      </div>
      @if (prices.giftCardDiscount !== 0) {
        <div>
          <label for="gift-card-remaining">{{ giftCardRemainingValuePriceLabel }}</label>
          <span id="gift-card-remaining">{{ prices.giftCardRemaining | number: '.2' : locale }} {{ currency | displayCurrency }}</span>
        </div>
      }
      @if (promotionForm?.controls.promotionCode; as control) {
        <div class="discount-code">
          <label for="discount-code">{{ promotionCodeLabel }}</label>
          <form id="discount-code" [formGroup]="promotionForm" (ngSubmit)="submitDiscount()">
            <app-text-input [control]="control" [placeholder]="promotionCodePlaceholder" subscriptSizing="dynamic">
              @if (control.hasError('invalid-code')) {
                <mat-error>Ugyldig kode</mat-error>
              }
            </app-text-input>
            <app-text-button>{{ promotionCodeButton }}</app-text-button>
          </form>
        </div>
      }
      @if (!useAgeVerification && containsAlcohol$ | async) {
        <div class="age-restricted">
          <div>
            <label for="age-restricted">{{ ageRestrictedLabel }}<span>*</span></label>
            <app-toggle id="age-restricted" [control]="form?.controls?.legalAgeConsent"></app-toggle>
          </div>
          <img
            src="assets/images/sundhedsstyrelsen.png"
            alt="Aldersgrænse for salg: 16 år for alkohol under 16,5% og 18 år for alkohol fra 16,5%"
          />
        </div>
      }
      @if (contactInformation && !isKiosk) {
        <div class="contact">
          <label for="contact-information" tabindex="0">{{ contactInformation }}</label>
          @if (contactPhoneNumber) {
            <a class="contact-number unstyled-link" [href]="'tel:' + contactPhoneNumber">
              <mat-icon svgIcon="contact"></mat-icon> {{ contactPhoneNumber }}
            </a>
          }
        </div>
      }

      @if (!eventShop && !isKiosk && !disableNote && form) {
        <div class="note-field-wrapper">
          <app-text-input
            class="note-field"
            [control]="form.controls.payment.controls.note"
            [name]="noteLabel"
            [subtitle]="noteSubtitle"
            [placeholder]="notePlaceholder"
            [textarea]="true"
          ></app-text-input>
        </div>
      } @else if (!eventShop && !isKiosk && noteLabel) {
        <div class="note-label">
          <span class="title">{{ noteLabel }}</span>
          @if (noteSubtitle) {
            <span class="subtitle">{{ noteSubtitle }}</span>
          }
        </div>
      }
      <div class="payment">
        <app-payment-options></app-payment-options>
        @if ((shippingValid$ | async) === false) {
          <span class="missing-shipping">{{ missingShippingText }}</span>
        }
        <app-text-button (click)="checkout()" [disabled]="!isValidState || storeClosed">{{ checkoutButton }}</app-text-button>
      </div>
    </app-center-section>
  </table>
</div>
